module.exports = __webpack_public_path__ + "media/images/next-arrow-6ee9ccc77fa7a52a84144f957796f0a1.png";